import React from 'react';
import {VideoEditorState} from '../store/VideoEditorStore';
import styles from './ChunkListOverlay.module.css';
import {VideoEditorText} from '../VideoEditorText';
import LoadingSpinner from '../../../uiToolkit/LoadingSpinner/LoadingSpinner';

interface Props {
  state: VideoEditorState;
  isLoading: boolean;
  refreshChunks: () => void;
  isEditingTemporaryDisabled?: boolean;
  forceWorking?: boolean;
  suppressWorkingOverlay?: boolean;
}

const ChunkListOverlay: React.FC<Props> = ({
  state,
  isLoading,
  refreshChunks,
  isEditingTemporaryDisabled,
  forceWorking = false,
  suppressWorkingOverlay = false,
}: Props) => {
  const getLoadingText = (
    state: VideoEditorState,
    editingDisabled?: boolean,
  ) => {
    if (forceWorking || editingDisabled || state !== VideoEditorState.Idle) {
      return VideoEditorText.stateWorking;
    }
    return '';
  };

  const getSpinnerIcon = () => {
    return (
      <span>
        <LoadingSpinner size={24} />
      </span>
    );
  };

  return (
    <div>
      {!suppressWorkingOverlay &&
        (isLoading ||
          state !== VideoEditorState.Idle ||
          isEditingTemporaryDisabled ||
          forceWorking) && (
          <div className={styles.overlay}>
            <span className={styles.loadingText} onClick={refreshChunks}>
              {getSpinnerIcon()}
              {getLoadingText(state, isEditingTemporaryDisabled)}
            </span>
          </div>
        )}
    </div>
  );
};
export default ChunkListOverlay;
